<template>
  <div>
    <v-main>
      <v-app-bar flat class="v-toolbar__content px-4 border-b">
        <v-app-bar-title @click="goToHome">
          <img :src="store.appConfiguration.images.logo" :alt="store.appConfiguration.appName" height="35" class="mr-3">
        </v-app-bar-title>

        <v-btn v-if="isAdminOrRoot" color="primary" :to="{name: 'dashboard'}">
          <v-icon start>far fa-gauge</v-icon>
          {{ $t('components.MainNavigation.dashboard') }}
        </v-btn>

        <v-btn color="primary"
               v-if="
                 isAdminOrRoot
                   || store.hasSomeAbilities(Entity.Tenant)
                   || store.hasSomeAbilities(Entity.Institution)
                   || store.hasSomeAbilities(Entity.Cohort)"
               :to="{name: 'schoolsDashboard'}">
          <v-icon start>far fa-building</v-icon>
          My School
        </v-btn>

        <v-btn color="primary" v-if="isAdminOrRoot || store.hasSomeAbilities(Entity.User)"
               :to="{name: 'users'}">
          <v-icon start>far fa-users</v-icon>
          {{ $t('components.MainNavigation.users') }}
        </v-btn>

        <v-btn
          color="primary"
          v-if="isAdminOrRoot || store.hasSomeAbilities(Entity.AccessCode)"
          :to="{name: 'vouchers'}"
        >
          <v-icon start>far fa-ticket</v-icon>
          {{ $t('components.MainNavigation.vouchers') }}
        </v-btn>

        <v-btn color="primary" :to="{ name: 'reports' }">
          <v-icon start>far fa-chart-mixed</v-icon>
          {{ $t('components.MainNavigation.insights') }}
        </v-btn>

        <v-menu v-if="isAdminOrRoot">
          <template v-slot:activator="{ props }">
            <v-btn color="primary" v-bind="props" class="text-none custom-tab-btn no-hover" variant="text">
              <v-icon start>far fa-users</v-icon>
              {{ $t('components.MainNavigation.manage') }}
            </v-btn>
          </template>
          <v-list class="custom-list">
            <v-list-item
              v-if="isAdminOrRoot || store.hasSomeAbilities(Entity.Tenant)"
              :to="{name: 'tenants'}"
              prepend-icon="far fa-globe"
            >
              <v-list-item-title>{{ $t('components.MainNavigation.tenants') }}</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="isAdminOrRoot || store.hasSomeAbilities(Entity.Institution)"
              :to="{name: 'institutions'}"
              prepend-icon="far fa-school"
            >
              <v-list-item-title>{{ $t('components.MainNavigation.institutions') }}</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="isAdminOrRoot || store.hasSomeAbilities(Entity.Cohort)"
              :to="{name: 'cohorts'}"
              prepend-icon="far fa-graduation-cap"
            >
              <v-list-item-title>{{ $t('components.MainNavigation.cohorts') }}</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="isAdminOrRoot || store.hasSomeAbilities(Entity.Coupon)"
              :to="{name: 'coupons'}"
              prepend-icon="far fa-badge-percent"
            >
              <v-list-item-title>{{ $t('components.MainNavigation.coupons') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-spacer/>

        <v-btn
          variant="outlined"
          color="text-grey-darken-1"
          append-icon="far fa-search"
          data-pw="globalSearchButton"
          @click="openGlobalSearch"
          size="large"
          class="mr-2"
        >
          {{ $t('common.search') }}
        </v-btn>

        <v-menu>
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              variant="outlined"
              size="large"
              color="text-grey-darken-1 bg-grey-lighten-3"
            >
              <v-icon
                color="grey-darken-1"
                size="small"
              >
                far fa-gear
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-if="isAdminOrRoot"
              :to="{name: 'configuration'}"
              prepend-icon="far fa-puzzle-piece"
            >
              <v-list-item-title>{{ $t('components.MainNavigation.configuration') }}</v-list-item-title>
            </v-list-item>
            <v-list-item
              :to="{name: 'userSettings'}"
              prepend-icon="far fa-gears"
            >
              <v-list-item-title>{{ $t('components.MainNavigation.account') }}</v-list-item-title>
            </v-list-item>
            <v-list-item
              @click="logout"
              prepend-icon="far fa-sign-out"
            >
              <v-list-item-title>{{ $t('components.MainNavigation.logout') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>

      <v-app-bar v-if="backRoute || breadcrumbs" flat class="v-toolbar__content px-4 border-b" density="compact">
        <app-breadcrumbs :back-route="backRoute" :items="breadcrumbs"/>
      </v-app-bar>

      <div>
        <v-container fluid>
          <template v-if="$slots.headerNavigate || $slots.headerIcon || $slots.header || $slots.subHeader">
            <v-row class="align-center pt-4" dense no-gutters>
              <v-col cols="auto">
                <slot name="headerNavigate"/>
              </v-col>
              <v-col cols="auto" v-if="$slots.headerIcon" class="mr-2">
                <div class="bg-primary rounded-lg py-1 px-2">
                  <v-icon size="x-small" color="white">
                    <slot name="headerIcon"/>
                  </v-icon>
                </div>
              </v-col>
              <v-col class="text-h4 font-weight-bold" cols=" auto">
                <slot name="header"/>
              </v-col>

              <v-col cols="12">
                <span v-if="$slots.subHeader" class=" d-block">
                  <slot name="subHeader"/>
                </span>
              </v-col>
            </v-row>

          </template>
          <v-row v-if="$slots['context-menu']"  dense
                 no-gutters>
            <v-spacer/>
            <v-col class="d-flex flex-row justify-end" cols="auto">
              <slot name="context-menu"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <slot/>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-main>
  </div>

  <v-dialog
    v-model="isSearchDialogOpen"
    width="600"
  >
    <global-search-bar @close="closeGlobalSearchDialog"/>
  </v-dialog>
</template>

<script setup lang="ts">
import {useGlobalStore} from "@/store";
import {computed, ref, watch} from "vue";
import {Entity, Role} from "@YenzaCT/sdk";
import {useRoute, useRouter} from "vue-router";
import GlobalSearchBar from "@/components/GlobalSearch/GlobalSearchBar.vue";
import AppBreadcrumbs, {BreadcrumbItem} from "@/components/AppBreadcrumbs.vue";

const store = useGlobalStore();
const route = useRoute();
const router = useRouter();
const logout = async () => {
  await store.logout();
};
const isAdminOrRoot = ref(store.user?.app.role === Role.Admin || store.user?.app.role === Role.Root);

interface Props {
  backRoute?: unknown; // Vue Router location for back button
  breadcrumbs?: BreadcrumbItem[];
}

defineProps<Props>();

const activeTab = ref<string | null>(null);
const isSearchDialogOpen = ref(false);
const isManageActive = computed(() => {
  const manageRoutes = ["tenants", "institutions", "cohorts", "coupons"];
  return manageRoutes.includes(route.name as string);
});

function goToHome() {
  router.push({name: "dashboard"});
}

function openGlobalSearch() {
  isSearchDialogOpen.value = true;
}

function closeGlobalSearchDialog() {
  isSearchDialogOpen.value = false;
}

// Watch for route changes to update activeTab
watch(
  () => route.name,
  (newRouteName) => {
    if (isManageActive.value) {
      activeTab.value = "manage";
    } else {
      activeTab.value = newRouteName as string | null;
    }
  },
  {immediate: true}
);

</script>

<style scoped>
.v-toolbar__content {
  margin-bottom: -1px;
}

.custom-tab-btn :deep(.v-btn__overlay, .v-btn--active) {
  opacity: 0;
}

.no-hover:hover {
  background-color: transparent !important;
}

.main-content {
  max-width: 1280px;
}
</style>
